import type * as THREE from "three";

/** Unit-box timber shares geometry. Orient all texture channels per member,
 * using its local scale so rotating the sauna cannot rotate grain across it. */
export function applyTimberGrain(material: THREE.MeshStandardMaterial): void {
	const previousHook = material.onBeforeCompile;
	const previousKey = material.customProgramCacheKey.bind(material);
	material.customProgramCacheKey = () => `${previousKey()}|timber-grain-v1`;
	material.onBeforeCompile = (shader, renderer) => {
		previousHook.call(material, shader, renderer);
		const chunk = "#include <uv_vertex>";
		if (!shader.vertexShader.includes(chunk)) {
			throw new Error("[timberGrain] Missing uv_vertex shader chunk");
		}
		shader.vertexShader = shader.vertexShader.replace(
			chunk,
			`${chunk}
#if defined(USE_MAP) || defined(USE_NORMALMAP) || defined(USE_ROUGHNESSMAP)
  vec3 timberSize = vec3(length(modelMatrix[0].xyz), length(modelMatrix[1].xyz), length(modelMatrix[2].xyz));
  bool timberAlongX = timberSize.x > timberSize.y && timberSize.x >= timberSize.z;
  bool timberAlongZ = timberSize.z > timberSize.y && timberSize.z > timberSize.x;
  bool timberSwap = (timberAlongX && abs(normal.x) < 0.5) || (timberAlongZ && abs(normal.x) > 0.5);
  vec2 timberUv = timberSwap ? vec2(uv.y, 1.0 - uv.x) : uv;
  #ifdef USE_MAP
    vMapUv = (mapTransform * vec3(timberUv, 1.0)).xy;
  #endif
  #ifdef USE_NORMALMAP
    vNormalMapUv = (normalMapTransform * vec3(timberUv, 1.0)).xy;
  #endif
  #ifdef USE_ROUGHNESSMAP
    vRoughnessMapUv = (roughnessMapTransform * vec3(timberUv, 1.0)).xy;
  #endif
#endif`,
		);
	};
}
